import { Button } from "@/atoms-react/button/Button.react";
import { useCompany } from "@/features/company/hooks/use-company";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { Themes } from "@/types/theme";
import { getRoute, OlkyPassRoutes } from "@/utils/routes";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const CompanyOnboarding_DashboardCard = () => {
  const { t } = useTranslation(["pass", "error"]);
  const navigate = useNavigate();
  const { leUuid } = useCompanyContext();
  const { companyDetailQuery } = useCompany();
  const { data: companyDetails } = companyDetailQuery(leUuid);

  if (!companyDetails || companyDetails.legalEntity.AgentReviewFinish) {
    return null;
  }

  const waitingValidation = companyDetails.legalEntity.UserValidation;

  const translationKey = waitingValidation ? "waiting_card" : "card_cta";
  const tr = (key: string) => t(`company_onboarding.${translationKey}.${key}`);

  return (
    <div className="my-5 w-full rounded-sm border border-primary bg-primary/20 p-5 text-black dark:bg-primary-700 dark:text-white">
      <p className="font-bold">{tr("title")}</p>

      <p>{tr("description")}</p>

      {!waitingValidation && (
        <Button
          theme={Themes.white}
          className="mt-5 w-auto"
          onClick={() => navigate(getRoute(OlkyPassRoutes.company_onboarding, { company: leUuid }))}
        >
          {tr("cta")}
        </Button>
      )}
    </div>
  );
};
